import { useLocation } from 'react-router-dom'
import {
  StyledList,
  StyledGroup,
  StyledItem,
  GroupTitle,
  StyledGroupItem,
  StyledItemLink,
  ExpandIcon,
  StyledCollapse,
  StyledMenuCollapsed,
  StyledMenuCollapsedItem,
  StyledMenuCollapsedLink,
  StyledSkeletonList,
  StyledSkeleton
} from './styles'
import stores from '../../../stores/store'
import { useEffect, useRef, useState } from 'react'
import {
  ExpandMore,
  HelpOutline,
  KeyboardDoubleArrowLeft,
  Folder
} from '@mui/icons-material'
import {
  IconGroupAnaliseCadastral,
  IconGroupAnaliseRisco,
  IconGroupInfobusca,
  IconGroupServicosCartoriais,
  IconGroupSitiacaoVeicular,
  IconGroupVerificacaoCredito,
  IconCpfCnpjLight,
  IconCpfCnpjPeloEmail,
  IconCpfCnpjPeloNome,
  IconCpfCnpjCompleto,
  IconDddTelefone,
  IconGeolocalizacao,
  IconGeomarketing,
  IconLinhaDoTempo,
  IconListaTelefonica,
  IconMatrizFilial,
  IconNumeroBeneficio,
  IconOutrosDocumentos,
  IconPerfilCnpj,
  IconPerfilSocioEconomico,
  IconPessoaExpostaPoliticamente,
  IconRendaFaturamentoMensal,
  IconSimplesNacional,
  IconSintegra,
  IconSituacaoReceita,
  IconSituacaoReceitaCompleto,
  IconAdvancedBackgroundCheckABC,
  IconAlertaMonitore,
  IconBolsaFamilia,
  IconBuscaJudicial,
  IconCertidaoAntecedentesCriminaisCpfPoliciaFederal,
  IconClassificacaoBrasileiraOcupacaoCBO,
  IconDataMatch,
  IconDataValidBiometricaSimples,
  IconDataValidCadastralSimples,
  IconFaceCompare,
  IconFaturamentoGrupo,
  IconHistoricoAcademicoEscolar,
  IconIndicadorAtividade,
  IconLiveness,
  IconMercadoFinanceiro,
  IconMidiasNegativas,
  IconOcr,
  IconQuadroSocietarioAvancado,
  IconQuantidadeParticipacao,
  IconRestituicaoIRPF,
  IconServidorPublico,
  IconInfobusca,
  IconAcompanhamento,
  IconBuscaBens,
  IconCertidaoNegativaImoveis,
  IconMatriculaAtualizada,
  IconVeiculos,
  IconChequePlus,
  IconConcentre,
  IconCreditoBureau,
  IconCrednet,
  IconNegativacao,
  IconRecomenda,
  IconRelato,
  IconRelatorioBasico,
  IconRelatorioAvancado
} from '../../../assets/img/svg/logoFeatures'
import { Collapse } from '@mui/material'

const iconMapping: { [key: string]: JSX.Element } = {
  'Análise Cadastral': <IconGroupAnaliseCadastral />,
  'Registration Analysis': <IconGroupAnaliseCadastral />,
  'Análise de Risco': <IconGroupAnaliseRisco />,
  'Risk Analysis': <IconGroupAnaliseRisco />,
  Infobusca: <IconGroupInfobusca />,
  Infosearch: <IconGroupInfobusca />,
  'Serviços cartoriais': <IconGroupServicosCartoriais />,
  'Notary Services': <IconGroupServicosCartoriais />,
  'Situação Veicular': <IconGroupSitiacaoVeicular />,
  'Vehicle Status': <IconGroupSitiacaoVeicular />,
  'Verificação de Crédito': <IconGroupVerificacaoCredito />,
  'Credit Check': <IconGroupVerificacaoCredito />
}

const iconMappingItems: { [key: string]: JSX.Element } = {
  'Cpf/Cnpj light': <IconCpfCnpjLight />,
  'Light Cpf/Cnpj': <IconCpfCnpjLight />,

  'Cpf/Cnpj pelo e-mail': <IconCpfCnpjPeloEmail />,
  'Cpf/Cnpj by E-mail': <IconCpfCnpjPeloEmail />,

  'Cpf/Cnpj pelo nome': <IconCpfCnpjPeloNome />,
  'Cpf/Cnpj by Name': <IconCpfCnpjPeloNome />,

  'CpfCnpj completo': <IconCpfCnpjCompleto />,
  'Full Cpf/Cnpj': <IconCpfCnpjCompleto />,

  'DDD + telefone': <IconDddTelefone />,
  'Area Code + Phone Number': <IconDddTelefone />,

  Geolocalização: <IconGeolocalizacao />,
  'Address by coordinates': <IconGeolocalizacao />,

  Geomarketing: <IconGeomarketing />,

  'Linha do tempo': <IconLinhaDoTempo />,
  Timeline: <IconLinhaDoTempo />,

  'Lista telefônica': <IconListaTelefonica />,

  'Matriz / filial': <IconMatrizFilial />,
  'Headquarters or Branch': <IconMatrizFilial />,

  'Número do benefício': <IconNumeroBeneficio />,
  'Benefit Number': <IconNumeroBeneficio />,

  'Outros documentos': <IconOutrosDocumentos />,
  'Other Documents': <IconOutrosDocumentos />,

  'Perfil cnpj': <IconPerfilCnpj />,
  'Cnpj Profile': <IconPerfilCnpj />,

  'Perfil sócio econômico': <IconPerfilSocioEconomico />,
  'Socio-economic Profile': <IconPerfilSocioEconomico />,

  'Pessoa exposta politicamente': <IconPessoaExpostaPoliticamente />,
  'Politically exposed person': <IconPessoaExpostaPoliticamente />,

  'Quadro societário / Participação em empresa(s)': (
    <IconQuadroSocietarioAvancado />
  ),
  'Corporate Membership / Stake in Company(ies)': (
    <IconQuadroSocietarioAvancado />
  ),

  'Renda / faturamento mensal': <IconRendaFaturamentoMensal />,
  'Monthly Income / Invoicing': <IconRendaFaturamentoMensal />,

  'Simples nacional': <IconSimplesNacional />,
  'Simple National': <IconSimplesNacional />,

  Sintegra: <IconSintegra />,

  'Situação receita': <IconSituacaoReceita />,
  'Revenue Situation': <IconSituacaoReceita />,

  'Situação Receita Completo': <IconSituacaoReceitaCompleto />,
  'Complete Revenue Status': <IconSituacaoReceitaCompleto />,

  'Advanced background check (ABC)': <IconAdvancedBackgroundCheckABC />,
  'Advanced Background Check (ABC)': <IconAdvancedBackgroundCheckABC />,

  'Alerta monitore': <IconAlertaMonitore />,
  'Monitor Alert': <IconAlertaMonitore />,

  'Bolsa Família': <IconBolsaFamilia />,
  'Family Allowance': <IconBolsaFamilia />,

  'Busca judicial': <IconBuscaJudicial />,

  'Certidão antecedentes criminais Cpf - Polícia Federal': (
    <IconCertidaoAntecedentesCriminaisCpfPoliciaFederal />
  ),
  'Federal Police Criminal Record Certificate for Individuals': (
    <IconCertidaoAntecedentesCriminaisCpfPoliciaFederal />
  ),

  'Classificação Brasileira de Ocupação (CBO)': (
    <IconClassificacaoBrasileiraOcupacaoCBO />
  ),
  'Brazilian Classification of Occupations (CBO)': (
    <IconClassificacaoBrasileiraOcupacaoCBO />
  ),

  'Data match': <IconDataMatch />,
  'Data Match': <IconDataMatch />,

  'Data Valid - Biometrica Simples': <IconDataValidBiometricaSimples />,
  'Data Valid - Simple Biometric': <IconDataValidBiometricaSimples />,

  'Data Valid - Cadastral Simples': <IconDataValidCadastralSimples />,
  'Data Valid - Simple Registration': <IconDataValidCadastralSimples />,

  'Face compare': <IconFaceCompare />,

  'Faturamento Grupo': <IconFaturamentoGrupo />,
  'Group Billing': <IconFaturamentoGrupo />,

  'Histórico Acadêmico e Escolar': <IconHistoricoAcademicoEscolar />,
  'Academic Transcript': <IconHistoricoAcademicoEscolar />,

  'Indicador de atividade': <IconIndicadorAtividade />,
  'Activity indicator': <IconIndicadorAtividade />,

  Liveness: <IconLiveness />,

  'Mercado financeiro': <IconMercadoFinanceiro />,
  'Financial market': <IconMercadoFinanceiro />,

  'Midias negativas': <IconMidiasNegativas />,
  'Negative Media': <IconMidiasNegativas />,

  Ocr: <IconOcr />,

  'Quadro societário avançado': <IconQuadroSocietarioAvancado />,
  'Advanced Corporate Governance': <IconQuadroSocietarioAvancado />,

  'Quantidade de Participação': <IconQuantidadeParticipacao />,
  'Participation Quantity': <IconQuantidadeParticipacao />,

  'Restituição IRPF': <IconRestituicaoIRPF />,
  'Restitution IRPF': <IconRestituicaoIRPF />,

  'Servidor público': <IconServidorPublico />,
  'Public Servant': <IconServidorPublico />,

  Infobusca: <IconInfobusca />,
  InfoSeek: <IconInfobusca />,

  Acompanhamento: <IconAcompanhamento />,
  Tracking: <IconAcompanhamento />,

  'Busca bens': <IconBuscaBens />,
  'Search for assets': <IconBuscaBens />,

  'Certidão negativa imóveis': <IconCertidaoNegativaImoveis />,
  'Negative certificate of property': <IconCertidaoNegativaImoveis />,

  'Matrícula atualizada': <IconMatriculaAtualizada />,
  'Updated registration': <IconMatriculaAtualizada />,

  Veículos: <IconVeiculos />,
  Vehicles: <IconVeiculos />,

  'Cheque plus': <IconChequePlus />,
  'Check Plus': <IconChequePlus />,

  Concentre: <IconConcentre />,

  'Crédito Bureau': <IconCreditoBureau />,
  'Credit Bureau': <IconCreditoBureau />,

  Crednet: <IconCrednet />,

  Negativação: <IconNegativacao />,
  Negativation: <IconNegativacao />,

  Recomenda: <IconRecomenda />,
  Recommends: <IconRecomenda />,

  Relato: <IconRelato />,

  'Relatório Básico': <IconRelatorioBasico />,
  'Basic Report': <IconRelatorioBasico />,

  'Relatório Avançado': <IconRelatorioAvancado />,
  'Advanced Report': <IconRelatorioAvancado />
}

export default function SidebarLeft() {
  const { jsonSelected: lang } = stores.DataLocaleStore()
  const { loadingList } = stores.DataLoadingStore()
  const { listSidebar } = stores.DataSidebarStore()
  const { hideHeader, setHideHeader } = stores.DataHideHeaderStore()
  const { setLeftMenuItemSelected } = stores.DataLeftMenuSelected()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search).toString()
  const listRef = useRef<HTMLUListElement>(null)
  const [collapsedGroups, setCollapsedGroups] = useState<{
    [key: string]: boolean
  }>({})
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false)

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [selectedGroup, setSelectedGroup] = useState<string | null>(null)
  const openMenu = Boolean(anchorEl)
  const handleHover = (
    event: React.MouseEvent<HTMLDivElement>,
    groupName: string
  ) => {
    setAnchorEl(event.currentTarget)
    setSelectedGroup(groupName)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setSelectedGroup(null)
  }

  useEffect(() => {
    const initialState: { [key: string]: boolean } = {}
    listSidebar.forEach(
      (group: { name: string; list: { href: string; path: string }[] }) => {
        const isGroupOpen = group.list.some(
          (item) => item.path === location.pathname
        )
        initialState[group.name] = !isGroupOpen
      }
    )

    const itemSelected = listSidebar
      .flatMap((group) => group.list)
      .find((item) => item.path === location.pathname)

    if (itemSelected) {
      setLeftMenuItemSelected(itemSelected.name)
    }

    setCollapsedGroups(initialState)
  }, [listSidebar, location.pathname])

  useEffect(() => {
    const handleWheel = (event: WheelEvent) => {
      const element = listRef.current
      if (!element) return

      const isAtTop = element.scrollTop === 0
      const isAtBottom =
        element.scrollHeight - element.scrollTop === element.clientHeight

      if ((event.deltaY > 0 && isAtBottom) || (event.deltaY < 0 && isAtTop)) {
        setHideHeader(event.deltaY > 0)
      }
    }

    const element = listRef.current
    element?.addEventListener('wheel', handleWheel)

    return () => {
      element?.removeEventListener('wheel', handleWheel)
    }
  }, [])

  const toggleGroup = (event: any, groupName: string) => {
    if (isMenuCollapsed) {
      handleHover(event, groupName)
    }

    setCollapsedGroups((prevState) => ({
      ...prevState,
      [groupName]: !prevState[groupName]
    }))
  }

  const handleCollapseMenu = () => {
    setIsMenuCollapsed((prevState) => !prevState)
    if (!isMenuCollapsed) {
      setCollapsedGroups((prevState) => {
        const newState = { ...prevState }
        Object.keys(newState).forEach((key) => {
          newState[key] = true
        })
        return newState
      })
    }
  }

  return (
    <>
      {loadingList ? (
        <StyledSkeletonList>
          <StyledSkeleton width={290} height={40} />
          <StyledSkeleton width={290} height={40} />
          <StyledSkeleton width={290} height={40} />
          <StyledSkeleton width={290} height={40} />
          <StyledSkeleton width={290} height={40} />
          <StyledSkeleton width={290} height={40} />
          <StyledSkeleton width={290} height={40} />
        </StyledSkeletonList>
      ) : (
        <StyledList
          ref={listRef}
          $hideHeader={hideHeader}
          $menuCollapsed={isMenuCollapsed}
        >
          {listSidebar.map(
            (group: {
              name: string
              list: { name: string; href: string; path: string }[]
            }) => (
              <StyledGroup key={group.name} $menuCollapsed={isMenuCollapsed}>
                <GroupTitle
                  onClick={(e) => toggleGroup(e, group.name)}
                  $menuCollapsed={isMenuCollapsed}
                >
                  <span>
                    {iconMapping[group.name as keyof typeof iconMapping] || (
                      <HelpOutline />
                    )}
                    {!isMenuCollapsed && group.name}
                  </span>
                  {!isMenuCollapsed && (
                    <ExpandIcon open={!collapsedGroups[group.name]}>
                      <ExpandMore />
                    </ExpandIcon>
                  )}
                </GroupTitle>
                {!isMenuCollapsed && collapsedGroups && group && group.list && (
                  <Collapse
                    in={!collapsedGroups[group.name]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <StyledGroupItem>
                      {group.list.map((item) => (
                        <StyledItemLink
                          to={`${item.path}${queryParams ? `?${queryParams}` : ''}`}
                          key={item.href}
                        >
                          <StyledItem
                            selected={item.path === location.pathname}
                          >
                            {iconMappingItems[item.name] || <Folder />}
                            {item.name}
                          </StyledItem>
                        </StyledItemLink>
                      ))}
                    </StyledGroupItem>
                  </Collapse>
                )}

                {isMenuCollapsed && selectedGroup === group.name && (
                  <StyledMenuCollapsed
                    anchorEl={anchorEl}
                    open={openMenu}
                    onClose={handleClose}
                    $menuCollapsed={isMenuCollapsed}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left'
                    }}
                  >
                    {group.list.map((item) => (
                      <StyledMenuCollapsedLink
                        to={`${item.path}${queryParams ? `?${queryParams}` : ''}`}
                        key={item.href}
                      >
                        <StyledMenuCollapsedItem onClick={handleClose}>
                          {iconMappingItems[item.name] || <Folder />}
                          {item.name}
                        </StyledMenuCollapsedItem>
                      </StyledMenuCollapsedLink>
                    ))}
                  </StyledMenuCollapsed>
                )}
              </StyledGroup>
            )
          )}
          <StyledCollapse
            onClick={handleCollapseMenu}
            $menuCollapsed={isMenuCollapsed}
          >
            <KeyboardDoubleArrowLeft />{' '}
            {!isMenuCollapsed && lang.navbar.collapseMenu}
          </StyledCollapse>
        </StyledList>
      )}
    </>
  )
}
